<template>
  <div
    class="profile"
    v-if="serviceProfile != ''"
    :class="{ success: modalRequestComponentName == 'success' }"
  >
    <div class="i_n">
      <div class="image">
        <img
          v-if="serviceProfile.profileImage"
          v-imageLoading="serviceProfile.profileImage.url"
        />
        <img v-else src="@/assets/images/common/Profile-icon.png" />
      </div>
      <div class="name">
        <div class="deco">Booking With</div>
        <div class="pname">
          {{ serviceProfile.name }}
          {{ serviceProfile.firstName }}
        </div>
      </div>
    </div>
    <div class="infos">
      <ul>
        <li class="item-k">WHAT FOR</li>
        <li class="item-v">{{ serviceDetail.speciality }}</li>
        <li class="item-k" v-if="modalRequestComponentName == 'success'">
          DATE
        </li>
        <li class="item-v" v-if="modalRequestComponentName == 'success'">
          {{ requestBookingInfo.date }}
        </li>
        <li class="item-k" v-if="modalRequestComponentName == 'success'">
          TIME
        </li>
        <li class="item-v" v-if="modalRequestComponentName == 'success'">
          {{ requestBookingInfoTime }}
        </li>
        <li class="item-k">Location</li>
        <li class="item-v" v-if="requestBookingInfo">
          {{ requestBookingInfo.location.address.detail }}
        </li>
      </ul>
    </div>
    <div class="total-price">
      <h2>TOTAL</h2>
      <span v-currency="serviceDetail.currencyUnit"></span>
      {{ serviceDetail.price }}
    </div>
    <div class="contact" v-if="modalRequestComponentName != 'success'">
      <button type="button" class="button back" @click="back">BACK</button>
      <!--<button type="button" class="button save">UNSAVE-->
      <!--</button>-->
      <button
        v-if="modalRequestComponentName == 'payment'"
        type="button"
        @click="checkOut"
        class="button next"
      >
        CHECK OUT
      </button>
      <button v-else type="button" @click="checkout" class="button next">
        CHECK OUT
      </button>
    </div>
    <vue-stripe-checkout
      v-if="requestBookingInfo"
      ref="checkoutRef"
      :image="image"
      :name="userInfo.firstName + userInfo.name"
      :description="requestBookingInfo.location.address.detail"
      currency="£"
      :amount="parseInt(serviceDetail.price, 10)"
      :allow-remember-me="false"
      @done="done"
      @opened="opened"
      @closed="closed"
      @canceled="canceled"
    ></vue-stripe-checkout>
  </div>
</template>

<script>
import * as types from '../../store/mutation-types'
import { mapGetters } from 'vuex'
import mixinPrice from '../../mixin/price'
import { serverTime } from '../../library/firebase'
import { requestReservation, savePayment } from '../../api/reservation'
import mixCommon from '../../mixin/common'
import * as firebaseConnection from 'firebase'
// todo 데이터를 세팅하기전에 랜더링이 먼저 되서 그런거니 랜더링을 하기전에 데이터를 검증하고나서 랜더링을 해야 한다.
export default {
  mixins: [mixinPrice, mixCommon],
  name: 'profile',
  data() {
    return {
      image: ''
    }
  },
  mounted() {
    firebaseConnection
      .storage()
      .ref(this.userInfo.profileImage.url)
      .getDownloadURL()
      .then(url => {
        this.image = url
      })
  },
  methods: {
    async checkout() {
      // token - is the token object
      // args - is an object containing the billing and shipping address if enabled
      if (
        typeof this.serviceProfile.profileImage !== 'undefined' &&
        this.serviceProfile.profileImage.url
      ) {
        // const { token, args } = await this.$refs.checkoutRef.open()
        await this.$refs.checkoutRef.open()
      } else {
        alert('Upload your profile photo.')
      }
    },
    done({ token, args }) {
      // token - is the token object
      // args - is an object containing the billing and shipping address if enabled
      // do stuff...
      console.log(token, args)
      const checkValidation = this.requestBookingInfo
      if (checkValidation.reservation === '') {
        alert('Select your booking date and time.')
      } else {
        if (
          Object.entries(token).length > 0 &&
          typeof this.serviceProfile.profileImage !== 'undefined' &&
          this.serviceProfile.profileImage.url
        ) {
          const requestData = Object.assign(
            {},
            this.$store.getters.requestBookingInfo,
            {
              status: 'request',
              createDate: serverTime,
              uid: this.$store.getters.userInfo.uid,
              serviceId: this.serviceDetail.id,
              photographerId: this.serviceDetail.uid,
              price: this.serviceDetail.price,
              photographerName: this.serviceDetail.name,
              currencyUnit: this.serviceDetail.currencyUnit,
              photographerProfileImage: this.serviceProfile.profileImage.url,
              userName: this.$store.getters.userInfo.name,
              userProfileImage: this.$store.getters.userInfo.profileImage.url,
              rating: 0
            }
          )

          console.log(requestData)
          requestReservation(requestData).then(res => {
            console.log('add: ', res)
            savePayment(res.id, {
              price: this.serviceDetail.price,
              ...token
            }).then(payment => {
              console.log('payment: ', payment)
              this.$store.dispatch(types.SET_MODAL_REQUEST_COMPONENT, {
                component: 'success',
                propData: {
                  serviceId: this.serviceDetail.id
                }
              })
            })
          })
        } else {
          alert('Upload your profile photo.')
        }
      }
    },
    opened() {
      // do stuff
    },
    closed() {
      // do stuff
    },
    canceled() {
      // do stuff
    },
    back() {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: 'request',
        active: true,
        type: 'full',
        propData: {
          serviceId: this.serviceDetail.id
        }
      })
      // this.$store.dispatch(types.SET_MODAL_ALERT_FOOTER, {active: true, text: 'Saved', propData: {} })
    },
    requestToNext() {
      // console.log(this.serviceDetail)
      const checkValidation = this.requestBookingInfo
      if (checkValidation.reservation === '') {
        alert('Select your booking date and time.')
      } else {
        this.$store.dispatch(types.SET_MODAL_REQUEST_COMPONENT, {
          component: 'payment',
          propData: {
            serviceId: this.serviceDetail.id
          }
        })
      }
    },
    checkOut() {
      // 부킹 저장을 한다.
      if (
        typeof this.serviceProfile.profileImage !== 'undefined' &&
        this.serviceProfile.profileImage.url
      ) {
        const requestData = Object.assign(
          {},
          this.$store.getters.requestBookingInfo,
          {
            status: 'request',
            createDate: serverTime,
            uid: this.$store.getters.userInfo.uid,
            serviceId: this.serviceDetail.id,
            photographerId: this.serviceDetail.uid,
            price: this.serviceDetail.price,
            photographerName: this.serviceDetail.name,
            currencyUnit: this.serviceDetail.currencyUnit,
            photographerProfileImage: this.serviceProfile.profileImage.url,
            userName: this.$store.getters.userInfo.name,
            userProfileImage: this.$store.getters.userInfo.profileImage.url,
            rating: 0
          }
        )

        console.log(requestData)
        requestReservation(requestData).then(res => {
          console.log('add: ', res)
        })

        this.$store.dispatch(types.SET_MODAL_REQUEST_COMPONENT, {
          component: 'success',
          propData: {
            serviceId: this.serviceDetail.id
          }
        })
      } else {
        alert('Upload your profile photo.')
      }
    }
  },
  computed: {
    ...mapGetters([
      'serviceProfile',
      'serviceDetail',
      'modalRequestComponentName',
      'requestBookingInfo',
      'userInfo'
    ]),
    requestBookingInfoTime() {
      const start = Object.keys(this.requestBookingInfo.reservation)[0]
      const end = this.requestBookingInfo.reservation[start].endTime / 60
      return `${start / 60}:00 - ${end}:00`
    }
  },
  watch: {
    requestBookingInfo(data) {
      console.log('profile: ', data)
    }
  },
  directives: {
    language: {
      bind(el, binding, vnode) {
        // console.log(el, binding, vnode)
        console.log(binding)
        binding.value.forEach((item, index) => {
          console.log(item.codeName, index)
          if (index === binding.value.length - 1) {
            vnode.elm.innerText += item.codeName
          } else {
            vnode.elm.innerText += item.codeName + ','
          }
          // console.log('index:', index, binding.value.length)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.profile {
  width: 95%;
  height: 500px;
  position: relative;

  .i_n {
    .image {
      position: absolute;
      left: 0;
      top: 0;

      img {
        object-fit: cover;
        width: 75px;
        height: 75px;
      }
    }

    .name {
      margin: 0 0 0 85px;
      height: 75px;

      .deco {
        font-family: Poppins;
        font-size: 17px;
        font-weight: 300;
        color: #000;
        margin: 3px 0 0 0;
      }

      .pname {
        font-family: Poppins;
        font-size: 17px;
        font-weight: 600;
        color: #000;
        margin: 3px 0 0 0;
      }
    }
  }

  .infos {
    position: relative;
    margin: 24px 0 0 38px;

    ul {
      margin: 0;
      padding: 0;

      li {
        font-family: Poppins;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;

        &.item-k {
          font-weight: 600;
        }

        &.item-v {
          margin: 3px 0 17px 0;
          font-weight: 300;
        }
      }
    }
  }

  .total-price {
    h2 {
      font-weight: 600;
    }

    position: absolute;
    bottom: 140px;
    left: 38px;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.1px;
    text-align: left;
    color: #000000;
  }

  .contact {
    position: absolute;
    left: 38px;
    bottom: 0;

    button {
      width: 200px;
      height: 50px;
      border: solid 1px #dddddd;
      border-radius: 2px;
      background-color: #000bff;
      outline: none;
      color: #fff;
      letter-spacing: 1px;
      font-size: 14px;
      cursor: pointer;

      &.back {
        background-color: #fff;
        color: #000;
        font-weight: 300;
      }

      &.next {
        font-weight: 600;
        margin: 10px 0 0 0;
        border: 1px solid #000bff;
      }
    }
  }

  &.success {
    height: 700px !important;
  }
}
</style>
